module.exports = __webpack_public_path__ + "img/0Q3B5909-12_H_WoodMatted.b240081e.jpg";